import {
    useSavedListingState,
    useSavedListingDispatch
} from 'listing-details/context';
import { addSavedListing, removeSavedListing } from 'listing-details/api/user';
import { ApolloClient } from '@apollo/client';

const useSavedListing = <T>(client?: ApolloClient<T>) => {
    const {
        listingId,
        isUser,
        isSaved,
        isSavedOptimistically,
        isUpdatingServer
    } = useSavedListingState();
    const dispatch = useSavedListingDispatch();

    // If we're in a non-ready state it's because the context hasn't been initialised
    // yet so we're waiting for this data to become available
    const isReady = listingId !== undefined && isUser !== undefined;

    const toggle = async (showAuth?: () => void) => {
        if (!isReady || isUpdatingServer) {
            return;
        }

        if (!isUser) {
            showAuth && showAuth();
            return;
        }

        const apiCall = isSaved ? removeSavedListing : addSavedListing;
        const actionOnSuccess = isSaved ? 'LISTING_REMOVED' : 'LISTING_SAVED';

        dispatch({
            type: 'UPDATE_SERVER_STARTED'
        });

        try {
            await (client
                ? apiCall(listingId as number, client)
                : apiCall(listingId as number));

            dispatch({
                type: actionOnSuccess
            });
        } catch (error) {
            dispatch({
                type: 'UPDATE_SERVER_FAILED'
            });
        }
    };

    const register = () => {
        dispatch({
            type: 'USER_REGISTERED'
        });
    };

    return {
        isReady,
        isUser,
        isSaved,
        isSavedOptimistically,
        listingId,
        toggle,
        register
    };
};

export default useSavedListing;
